import { render, staticRenderFns } from "./ImportTest.vue?vue&type=template&id=4c56c27c&"
import script from "./ImportTest.vue?vue&type=script&lang=ts&"
export * from "./ImportTest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports